// Unsent messages in embedded (task/campaign/collab) chats, keyed by chat id.
const drafts = new Map();

export const setChatDraft = (chatId, draft) => (draft ? drafts.set(chatId, draft) : drafts.delete(chatId));
export const pendingChatDraft = () => [...drafts.values()][0] || null;
